import axios from "axios";

export default function createCompanyGroup({ name, selected }) {
  return new Promise((resolve, reject) => axios
    .post(`/account/system-admin/api/v1/company-group`, {
      name,
      items: selected,
    })
    .then((response) => resolve(response.data))
    .catch((error) => reject(error.message))
  );
}
